<style lang="scss" scoped>
@import "core";

$my-color-alert: #ffbdbd;
$my-color-success: $color-success;

.my-empty {
  &__reference {
    margin-top: 20px;

    & > dt {
      &:before { content: "＜"; }
      &:after  { content: "＞"; }
    }

    & > dd {}
  }

  &__footer {
    margin-top: 40px;

    & > dt {
      display: inline-block;
      &:after { content: "："; }
    }

    & > dd {
      display: inline-block;
      white-space: nowrap;
    }
  }
}

.my-block {
  margin: 10px 0;

  &__header {
    padding: 10px 0 7px;
  }
}

.my-box {
  border: solid 1px $color-divider;
  margin: 10px 0;

  &__header {
    position: relative;
    background: $color-primary-light;
    border-bottom: solid 1px $color-divider;
    padding: 13px 15px;
    text-align: center;
  }

  &__icon-self {
    position: absolute;
    right: 10px;
    top: 50%;
    margin-top: -12px;
  }

  &__body {
    padding: 10px 15px;
    text-align: center;
  }
}

.my-annotation {
  margin-top: 20px;
}

.my-accent-num {
  font-weight: bold;
  font-size: 18px;
}

.my-color-alert {
  background: $my-color-alert;
}

.my-color-success {
  background: $my-color-success;
}

.my-wrap {
  display: inline-block;
}

.my-single-score-input {
  width: 76px;
  text-align: center;
}

.my-empty-score {
  display: inline-block;
  vertical-align: middle;
  margin-top: .3em;

  & + .my-empty-icon {
    margin-left: 5px;
    margin-right: -30px;
  }
}

.my-linkto-about {
  text-align: right;
}
</style>



<template>
  <div class="pg-year">

    <!-- パターン③ -->
    <div v-if="isEmpty" class="my-empty">
      <p>大学が公表している合格者得点がありません。</p>

      <dl class="my-empty__reference">
        <dt>参考情報</dt>
        <dd>合格目標ラインは<a :href="goalLineUrl" target="_blank">こちら</a>をご確認ください。<br>※合格目標ラインがない大学は表示されません。</dd>
      </dl>

      <dl class="my-empty__footer">
        <dt>主催</dt>
        <dd>データネット実行委員会<wbr>ベネッセコーポレーション<wbr>／駿台予備学校</dd>
      </dl>
    </div>

    <!-- データがある時（※パターン③以外） -->
    <div v-else>
      <section>
        <h3 class="mdTtl03">センター試験の目標得点シミュレーション</h3>

        <!--
        -->
        <p class="my-linkto-about"><dn-icon icon="anchor" /> <a class="vam" href="javascript:void(0);" @click.stop="showAboutWindow(isCenter ? '1' : '2')">表の見方はこちら</a></p>

        <div class="my-block" v-for="dataKey in ['avg', 'min']" :key="dataKey">
          <h4 class="my-block__header mdTtl05">【合格者{{MESSAGES[dataKey]}}点の得点{{isCenter ? '率' : ''}}を目標にした場合】</h4>

          <p v-if="!mydata[dataKey]">大学が公表している合格者の{{MESSAGES[dataKey]}}点はありません。</p>
          <div v-else>

            <!-- パターン① -->
            <div v-if="isCenter">
              <dl class="my-box">
                <dt class="my-box__header">合格者{{MESSAGES[dataKey]}}得点率</dt>
                <dd class="my-box__body">
                  <span class="my-wrap"><span class="my-accent-num">{{mydata[dataKey].per * 100 | score}}</span>%</span><span class="my-wrap">（{{mydata[dataKey].score | score}}点/{{mydata.max}}点）</span>
                </dd>
              </dl>
              <dl class="my-box">
                <dt class="my-box__header">
                  あなたの自己採点得点率
                  <dn-icon class="my-box__icon-self" icon="self" btn :href="selfUrl" target="_blank" :title="`${year}年度 自己採点`" />
                </dt>
                <dd class="my-box__body">
                  <div v-if="hasTotals">
                    <span class="my-wrap"><span class="my-accent-num">{{totalHistory.per * 100 | score}}</span>%</span><span class="my-wrap">（{{totalHistory.score}}点/{{totalHistory.max}}点）</span>
                  </div>
                  <div v-else>
                    <span class="my-empty-score">{{MESSAGES.emptyScore}}</span>
                    <dn-icon class="my-empty-icon" icon="question" btn title="自己採点について" @click.native.stop="showSelfCheckDialog" />
                  </div>
                </dd>
              </dl>
              <hr class="dn-divider-tri--down">
              <dl class="my-box">
                <dt class="my-box__header">センター試験であと何点伸ばそう</dt>
                <dd
                  class="my-box__body my-accent-num"
                  :class="{
                    [`my-color-${mydata[dataKey].need <= 1 && mydata[dataKey].need !== null ? 'success' : 'alert'}`]: true
                  }"
                >
                  <div v-if="hasTotals">
                    <span class="my-wrap">{{mydata[dataKey].need | score}}点</span><span class="my-wrap">/{{totalHistory.max}}点</span>
                  </div>
                  <div v-else><span class="my-empty-score">{{MESSAGES.emptyScore}}</span></div>
                </dd>
              </dl>
            </div>

            <!-- パターン② -->
            <div v-if="isTotal">
              <dl class="my-box">
                <dt class="my-box__header">合格者{{MESSAGES[dataKey]}}点</dt>
                <dd class="my-box__body">
                  <span class="my-wrap">{{mydata[dataKey].score | score}}点</span><span class="my-wrap">/{{mydata.max | score}}点</span>
                </dd>
              </dl>
              <dl class="my-box">
                <dt class="my-box__header">
                  あなたの自己採点得点
                  <dn-icon class="my-box__icon-self" icon="self" btn :href="selfUrl" target="_blank" :title="`${year}年度 自己採点`" />
                </dt>
                <dd class="my-box__body">
                  <div v-if="hasTotals">
                    <span class="my-wrap">{{totalHistory.score}}点</span><span class="my-wrap">/{{totalHistory.max}}点</span>
                  </div>
                  <div v-else>
                    <span class="my-empty-score">{{MESSAGES.emptyScore}}</span>
                    <dn-icon class="my-empty-icon" icon="question" btn title="自己採点について" @click.native.stop="showSelfCheckDialog" />
                  </div>
                </dd>
              </dl>
              <dl class="my-box">
                <dt class="my-box__header">個別試験で何点取れるか入れよう</dt>
                <dd class="my-box__body">
                  <input
                    type="number"
                    class="my-single-score-input"
                    v-number-range
                    min="0"
                    :max="mydata.singleMax"
                    @change="onChangeSingleScore($event, dataKey)"
                    v-model.lazy="inputSingleScore[dataKey]"
                  >
                  <span class="my-wrap">/{{mydata.singleMax}}点</span>
                </dd>
              </dl>
              <hr class="dn-divider-tri--down">
              <dl class="my-box">
                <dt class="my-box__header">センター試験であと何点伸ばそう</dt>
                <dd
                  class="my-box__body my-accent-num"
                  :class="{
                    [`my-color-${mydata[dataKey].need <= 1 && mydata[dataKey].need !== null ? 'success' : 'alert'}`]: true
                  }"
                >
                  <span class="my-wrap">{{mydata[dataKey].need | score}}点</span><span class="my-wrap">/{{mydata.max - mydata.singleMax}}点</span>
                </dd>
              </dl>
            </div>

          </div>
        </div>

        <div class="my-annotation">
          <p>※このデータは、{{year}}年７月までに弊社が収集した各大学公表の情報を元に作成しており、合格最低点・平均点が公表されている募集単位のみ掲載しています。</p>
          <p>※「センター試験であと何点伸ばそう」の点数はあくまでも参考点です。この点数を伸ばすと必ず志望大に合格するといったものではありません。</p>
        </div>
      </section>

      <section class="mt30">
        <h3 class="mdTtl03">どの教科・科目で伸ばすか？</h3>
        <p>センター試験平均点と自己採点結果を比較し、差の大きい教科・科目から優先的に学習しよう</p>
        <div class="tac mt40">
          <dn-btn block-sp primary width-lg :href="avgScoreInfoUrl" target="_blank">平均点情報</dn-btn>
        </div>
      </section>
    </div>

  <dn-dialog
    ref="selfCheckDialog"
  >
    <h3 slot="header">自己採点結果が入力されていません。</h3>
    <p>「<a :href="`../self/index.html?year=${year}`">過去のセンター試験の自己採点をする</a>」から、自己採点を行ってください。</p>
    <div slot="footer">
      <dn-btn block-sp @click.native.stop="$refs.selfCheckDialog.hide">閉じる</dn-btn>
    </div>
  </dn-dialog>

  </div>
</template>



<script>
const MESSAGES = {
  avg       : '平均',
  min       : '最低',
  emptyScore: '***',
};



export default {
  props: {
    year: {
      type: [String, Number],
      required: true,
    },
    offer: {
      type: Object,
      required: true,
    },
    score: {
      type: Object,
      default: null,
    },
  },



  data() {
    return {
      MESSAGES: MESSAGES,
      subjectsState: 'pending',
      inputSingleScore: {},
    }
  },



  computed: {
    subjectsStoreName() { return `selfcheck-${this.year}` },
    subjectsIsReady() { return this.subjectsState === 'loaded' },
    totalHistory() { return this.$store.getters[`${this.subjectsStoreName}/totalHistory`] },

    /**
     * 表示パターン
     *   (1) center. 満点（センター）があって、かつ最低点（センター）、平均点（センター）のいずれかがある場合
     *   (2) total . 満点（個別）、満点（総合）があって、最低点（総合）、平均点（総合）のいずれかがある場合
     *   (3) empty . レコード自体がない、または上記のどの条件にも一致しない
     */
    pattern() {
      if (!this.score) return 'empty';
      if (this.hasCenterScore) return 'center';
      if (this.hasTotalScore) return 'total';
      return 'empty';
    },

    isCenter() { return this.pattern === 'center' },
    isTotal() { return this.pattern === 'total' },
    isEmpty() { return this.pattern === 'empty' },

    hasTotals() { return this.subjectsIsReady && this.totalHistory.per !== null },

    // 満点（センター）があって、かつ最低点（センター）、平均点（センター）のいずれかがあるか
    hasCenterScore() {
      return this.hasScore('center_max') && this.hasAnyScore('center_min', 'center_avg')
    },

    // 満点（個別）、満点（総合）があって、最低点（総合）、平均点（総合）のいずれかがある場合
    hasTotalScore() {
      return this.hasScore('single_max', 'total_max') && this.hasAnyScore('total_min', 'total_avg')
    },

    // 大学コード
    university_id() { return this.offer.id.slice(0, 4) },

    // 学部コード
    faculty_id() { return this.offer.id.slice(4, 6) },

    // 合格目標ラインのリンク先
    goalLineUrl() { return this.$store.getters['path/yearRoot'](this.year) + `/doukou/goukaku/${this.university_id}/${this.faculty_id}.html` },

    // 平均点情報のリンク先
    avgScoreInfoUrl() { return this.$store.getters['path/yearRoot'](this.year) + `/sokuhou/yosou/index.html` },

    // (1) center用のデータ
    centerData() {
      const data = {max: this.getScore('center_max')};

      for (let key of ['avg', 'min']) {
        data[key] = null;
        const score = this.getScore(`center_${key}`);
        if (score === null) continue;
        data[key] = {
          score: score,
          per  : score / data.max,
          need : null,
        };

        if (this.hasTotals) {
          data[key].need = Math.round(this.totalHistory.max * data[key].per - this.totalHistory.score);
        }
      }

      return data;
    },

    // (2) total用のデータ
    totalData() {
      const data = {max: this.getScore('total_max'), singleMax: this.getScore('single_max')};

      for (let key of ['avg', 'min']) {
        data[key] = null;
        const score = this.getScore(`total_${key}`);
        if (score === null) continue;
        data[key] = {
          score: score,
          need : score - (this.totalHistory && this.totalHistory.score || 0) - (this.inputSingleScore[key] || 0),
        };
      }

      return data;
    },

    // 自身のコンポーネント表示に必要なデータを表示パターンに応じて振り分け参照する
    mydata() {
      if (this.isCenter) {
        return this.centerData;
      } else if (this.isTotal) {
        return this.totalData;
      }
    },

    selfUrl() { return this.$store.getters['path/yearRoot'](this.year) + `/jikosaiten/index.html` },
    singleScoreLsKeySuf() { return `offer_single_score_${this.offer.id}_${this.year}_` },
  },



  methods: {

    /**
     * 得点データを参照する
     */
    getScore(key) {
      const score = this.score[`score_${key}`];
      return score === undefined ? null : score;
    },



    /**
     * 全ての引数の得点データが存在するかチェック
     */
    hasScore(...keys) {
      for (let key of keys) {
        if (this.getScore(key) === null) {
          return false;
          break;
        }
      }
      return true;
    },

    /**
     * 引数のうちのいずれかの得点データが存在するかチェック
     */
    hasAnyScore(...keys) {
      for (let key of keys) {
        if (this.hasScore(key)) {
          return true;
          break;
        }
      }
      return false;
    },



    /**
     * 科目情報モデルをロードする
     */
    async initSubjects() {
      this.subjectsState = 'loading';
      await this.$store.dispatch('loadSelfcheck', this.year);
      this.subjectsState = 'loaded';
    },



    /**
     * 個別入力点数変更時のコールバック
     * （ローカルストレージに保存する）
     */
    onChangeSingleScore(e, key) {
      let el    = e.target,
          value = parseInt(el.value);

      if (isNaN(value)) value = null;

      const lsKey = this.singleScoreLsKeySuf + key;
      this.$ls.set(lsKey, value);
    },



    /**
     * ローカルストレージから個別入力点数を復元する
     */
    restoreSingleScoreFromLs() {
      ['avg', 'min'].forEach(key => {
        const lsKey = this.singleScoreLsKeySuf + key,
              value = this.$ls.get(lsKey, null);

        this.$set(this.inputSingleScore, key, value);
      });
    },



    /**
     * 自己採点ダイアログを表示する
     */
    showSelfCheckDialog() {
      return this.$refs.selfCheckDialog.show();
    },



    /**
     * 「表の見方はこちら」ウィンドウを表示する
     */
    showAboutWindow(type) {
      return window.open(
        `./about${type}.html`,
        `dn-bible-myuniv-about-${type}`,
        'width=600, height=560, menubar=no, toolbar=no, scrollbars=yes'
      );
    },
  },



  filters: {
    score(score) {
      let value = typeof score === 'number' ? score : parseInt(score, 10);
      if (isNaN(value)) return score;
      return Math.round(value);
    },
  },



  created() {
    this.initSubjects();

    // ローカルストレージから個別入力点数を復元
    // ※ウォッチャも設定しておく
    this.restoreSingleScoreFromLs();
    dn.window.on('show', () => {
      this.restoreSingleScoreFromLs();
    });
  },
}
</script>



// WEBPACK FOOTER //
// ScoreYear.vue?06bd42b3